import { apiRequest } from './index';
export const wikiAPI = {
  // Structure
  getDocsifyStructure: async () => {
    const response = await apiRequest("/wiki/docsify/structure");
    return response; // Возвращаем полный response
  },

  // Folders
  getAllFolders: async () => {
    const response = await apiRequest("/wiki/folders");
    return response;
  },

  createFolder: async (folderData) => {
  
    const response = await apiRequest("/wiki/folders", {
      method: "POST",
      body: folderData,
    });

    return response;
  },

  deleteFolder: async (folderId) => {
    const response = await apiRequest(`/wiki/folders/${folderId}`, { 
      method: "DELETE" 
    });
    return response;
  },

  // Documents
  getDocument: async (documentId) => {
    const response = await apiRequest(`/wiki/documents/${documentId}`);
    return response;
  },

  getDocumentFiles: async (documentId) => {
    const response = await apiRequest(`/wiki/documents/${documentId}/files`);
    return response;
  },

  createDocument: async (documentData) => {
    const response = await apiRequest("/wiki/documents", {
      method: "POST",
      body: documentData, // Убедитесь, что created_by передается
    });
    return response;
  },

  updateDocument: async (documentId, documentData) => {
    const response = await apiRequest(`/wiki/documents/${documentId}`, {
      method: "PUT",
      body: documentData,
    });
    return response;
  },

  deleteDocument: async (documentId) => {
    const response = await apiRequest(`/wiki/documents/${documentId}`, { 
      method: "DELETE" 
    });
    return response;
  },


  // Files
   uploadFiles: async (documentId, files) => {
    if (!files) throw new Error('Files parameter is undefined or null');

    const formData = new FormData();
    formData.append('document_id', documentId.toString());
    
    const filesArray = Array.isArray(files) ? files : Array.from(files || []);
    if (filesArray.length === 0) throw new Error('No files selected for upload');

    filesArray.forEach(file => formData.append('files', file));

    const data = await apiRequest("/wiki/files/upload", {
      method: 'POST',
      body: formData,
    });
    
    if (!data.success) {
      throw new Error(data.error || 'Upload failed');
    }
    
    return data;
  },


  // Функции preview и download остаются как есть
  previewFile: async (fileId) => {
    return apiRequest(`/wiki/files/${fileId}/preview`, {
      responseType: 'blob',
    });
  },

  downloadFile: async (fileId) =>
    apiRequest(`/wiki/files/${fileId}/download`, {
      responseType: 'blob',
    }),

  deleteFile: (fileId) => 
    apiRequest(`/wiki/files/${fileId}`, { method: "DELETE" }),

  // Search
  searchDocuments: async (query) => {
    const response = await apiRequest(`/wiki/search?q=${encodeURIComponent(query)}`);
    return response.documents;
  }
};
